import {Component, Input, OnInit} from '@angular/core';
import {AOutDescription} from "../../analogout/analogoutDescription";
import {AOState} from "../../analogout/analogoutStatus";
import {AnalogoutlistComponent} from "../../analogout/analogoutlist/analogoutlist.component";
import {AnaloginlistComponent} from "../analoginlist/analoginlist.component";
import {AiRaw } from "../AiRawList";
import { MeasurementDescription} from "../../measurements/MeasurementDescriptionList";
import {sprintf} from "sprintf-js";

@Component({
  selector: 'app-analogindetails',
  templateUrl: './analogindetails.component.html',
  styleUrls: ['./analogindetails.component.css']
})
export class AnalogindetailsComponent implements OnInit {
  @Input()
  refNumber: number = -1;
  channelNr: number = 0;
  channelA: string = "";
  channelString: string = "";
  hexvalue: string = "0x0000";
  value: number = 0;
  aiDescription: MeasurementDescription;


  constructor(private analoginlistComponent: AnaloginlistComponent)  {
    analoginlistComponent.Add(this);
    this.aiDescription = new MeasurementDescription();
  }

  ngOnInit(): void {
    this.channelNr = Math.floor( this.refNumber / 2 ) + 1;
    this.channelA  = ((Math.floor( this.refNumber) % 2)==1) ? "A" : "-"
    this.channelString = sprintf("%02d%s",this.channelNr, this.channelA);
  }

  UpdateLayoutData(aiDescription: MeasurementDescription): void
  {
    this.aiDescription = aiDescription;
  }

  UpdateAiRaw(airaw: AiRaw): void
  {
    this.hexvalue = '0x' + ('00000'+(airaw.value).toString(16)).substr(-5).toUpperCase();
    this.value = airaw.value;
    console.log("AiRaw", airaw.value);
  }

  GetFullChannel(): number
  {
    return this.refNumber;
  }

}
